<template>
    <div>
        <TooltipBase :placement="`${tooltipLocalizacao}-center`" v-model="visible" name="nome">
            <div slot="outlet">{{texto}}</div>
            <div slot="tooltip">{{textoTooltip}}</div>
        </TooltipBase>
    </div>
</template>

<script>
import TooltipBase from './TooltipBase'

export default {
  components: {
    TooltipBase
  },
  name: 'TooltipUnimed',
  props: {
    visualizando: {
      type: String,
      default: '',
      note: 'V-model do tooltip'
    },
    texto: {
      type: String,
      default: '',
      required: false,
      note: 'Deve ser passado o nome do texto que ira aparecer'
    },
    textoTooltip: {
      type: String,
      default: '',
      required: true,
      note: 'Deve ser passado o nome do texto que ira aparecer no tooltip'
    },
    tooltipLocalizacao: {
      type: String,
      default: 'top',
      note: 'Deve ser passado onde tooltip ira aparecer em volta do texto que ira ser apresentado, escolher um dos valores: top,left,right,bottom'
    },
    nome: {
      type: String,
      default: '',
      require: false,
      note: 'Nome do campo'
    }
  },
  model: {
    prop: 'visualizando',
    event: 'input'
  },

  data () {
    return {
      visible: this.visualizando
    }
  }

}
</script>
